interface Props {
  allergens: string | undefined | null
  teams: string | undefined | null
  surpriseLink: string | undefined | null
  image?: string | undefined | null
}

export const Footer: React.FC<Props> = ({ image, allergens, teams, surpriseLink }) => {
  return (
    <div className="text-center font-mammaBody text-primary pt-10 border-t border-primary px-4 pb-28">
      {image && surpriseLink && (
        <a href={surpriseLink || '#'} target="_blank" rel="noopener noreferrer" className="mb-5">
          <img className="max-w-[500px] w-full mx-auto" alt="" src={image} />
        </a>
      )}

      {allergens && <p className="text-[14px] leading-[120%] whitespace-pre-wrap mb-2">{allergens}</p>}

      <hr className="border-0 border-t border-primary my-10" />

      {teams && <p className="text-[14px] leading-[120%] whitespace-pre-wrap">{teams}</p>}
    </div>
  )
}
